import fastdom from 'fastdom';

interface Config {
  selectors: {
    item: string
    trigger: string
    content: string
  }
}

export default class Accordion {
  container: HTMLElement;

  options: Config;

  constructor(node: HTMLElement, config?: Config) {
    this.container = node;
    this.options = { ...Accordion.defaults(), ...config };
  }

  static defaults(): Config {
    return {
      selectors: {
        item: '[data-accordion]',
        trigger: '[data-accordion-trigger]',
        content: '[data-accordion-content]',
      },
    };
  }

  init() {
    const accordions = this.container.querySelectorAll<HTMLElement>(this.options.selectors.item);

    if (!accordions.length) {
      return;
    }

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector<HTMLElement>(this.options.selectors.trigger);
      const content = accordion.querySelector<HTMLElement>(this.options.selectors.content);

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        Accordion.toggle({ accordion, trigger, content });
      });
    });
  }

  static toggle({
    accordion,
    trigger,
    content,
  }: {
    accordion: HTMLElement,
    trigger: HTMLElement,
    content: HTMLElement,
  }) {
    fastdom.mutate(() => {
      const height = !accordion.classList.contains('is-open') ? content.scrollHeight : 0;

      content.style.height = `${height}px`;
      content.setAttribute('aria-hidden', `${content.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'}`);
      trigger.setAttribute('aria-expanded', `${trigger.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'}`);
      accordion.classList.toggle('is-open');
    });
  }
}
